import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './ClinicDashboardLanding.css'; // Reuse existing styling

const ClinicDashboardLanding = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="manage-clinics-container">
      <h2 className="manage-clinics-title">{t('clinicDashboardLanding.title')}</h2>
  
      <div className="clinic-dashboard-grid">
        <button className="clinic-btn manage-clinics-btn" onClick={() => navigate('/admin/manage-clinics')}>
          {t('clinicDashboardLanding.manageClinics')}
        </button>
  
        <button className="clinic-btn register-customer-btn" onClick={() => navigate('/admin/register-customer')}>
          {t('clinicDashboardLanding.registerCustomer')}
        </button>
  
        <button className="clinic-btn manage-customers-btn" onClick={() => navigate('/admin/manage-customers')}>
          {t('clinicDashboardLanding.manageCustomers')}
        </button>
  
        <button className="clinic-btn visits-view-btn" onClick={() => navigate('/admin/clinic-visits-view')}>
          {t('clinicDashboardLanding.clinicVisitsView')}
        </button>
  
        <button className="clinic-btn public-clinics-btn" onClick={() => navigate('/public-clinics-landing')}>
          {t('public_listing.view_all_clinics')}
        </button>
        <button className="clinic-btn ai-insights-btn" onClick={() => navigate('/admin/clinic-ai-insights')}>
  🤖 {t('manageClinics.aiInsights')}
</button>

<button className="clinic-btn back-dashboard-btn" onClick={() => navigate('/dashboard')}>
  ⬅️ {t('manageClinics.backToDashboard')}
</button>
      </div>
    </div>
  );
};

export default ClinicDashboardLanding;
